import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { trackEventPayload } from "@src/util/track-event-payload";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";
import { useTracking } from "react-tracking";
import { InputSkeletonLayout } from "../../layout/input-skeleton-layout";

export const BaseVariantFilter: React.FC<{ form: FormInstance<any>; fieldName?: string }> = ({ form }) => {
  const { trackEvent } = useTracking();
  const isFirstRender = React.useRef(true);
  const variantsWatch: string[] = Form.useWatch(FilterFormFieldsEnum.VARIANTS, form);
  const variantsOptionsWatch = Form.useWatch(FilterFormFieldsEnum.VARIANTS_OPTIONS, form);
  const variantLoading = Form.useWatch(FilterFormFieldsEnum.IS_EXP_LOADING, form);

  const options = React.useMemo(() => {
    const getExpAliasById = (expId: string): string => {
      if (!variantsOptionsWatch) return "";
      const expGroup = variantsOptionsWatch?.find((item: any) => item?.value === expId);
      return expGroup?.label ?? expId;
    };
    return (variantsWatch ?? [])?.map((item: string) => {
      return {
        label: getExpAliasById(item),
        value: item,
      };
    });
  }, [JSON.stringify(variantsWatch, variantsOptionsWatch)]);

  // React.useEffect(() => {
  //   if (!variantsWatch) return;
  //   if (form.getFieldValue(FilterFormFieldsEnum.BASE_VARIANTS)) return;
  //   form.setFieldValue(FilterFormFieldsEnum.BASE_VARIANTS, variantsWatch?.[0]);
  // }, [JSON.stringify(variantsWatch)]);

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const currentValue = form.getFieldValue(FilterFormFieldsEnum.BASE_VARIANTS);
    if (!currentValue) return;
    if (!options?.some((option) => option.value === currentValue)) {
      form.setFieldValue(FilterFormFieldsEnum.BASE_VARIANTS, undefined);
    }
  }, [options]);

  return (
    <InputSkeletonLayout width={400} isLoading={variantLoading} label="Base variant" required>
      <Form.Item
        label="Base variant"
        name={FilterFormFieldsEnum.BASE_VARIANTS}
        required
        rules={[
          {
            message: "Please select base variant",
            required: true,
          },
        ]}
      >
        <SelectWithSpinAndCustomMaxTag
          options={options}
          style={{ width: 300 }}
          placeholder="Base variants"
          onChange={(value) => {
            trackEvent(trackEventPayload.baseMetricFieldUpdated("base_variant", value));
          }}
        />
      </Form.Item>
    </InputSkeletonLayout>
  );
};
